// Iter 30u: versione dell'app esposta nella UI (footer Impostazioni)
// Schema: MAJOR.MINOR.PATCH allineato al SW VERSION incrementato a ogni iter.
export const APP_VERSION = "1.199.0";
export const APP_NAME = "IL-Report";
export const APP_BRAND = "Made by IL-LAB";
